import type {
  ISeeMoreClassesQuery,
  ISeeMoreTeachersQuery,
} from '@/types/teacher';

import { EBlockUnblock, ERestoreEntityType } from '@/enum';
import { IAddTeacherPayload, IBlockUnblockPayload } from '@/types/payload';
import { formatQuery } from '@/utils';

import http from './http';
import serviceHelper from './serviceHelper';

export const getTeacherList = async (query?: Record<string, unknown>) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(http.get(`/school/teacher?${queryString}`), false);
};

export const removeTeacher = async (
  id: string,
  recordType: ERestoreEntityType
) => {
  return serviceHelper(
    http.delete(`/school/restore/${id}?record_type=${recordType}`),
    true
  );
};

export const blockUnblockUser = async (
  id: string,
  recordType: EBlockUnblock,
  payload: IBlockUnblockPayload
) => {
  return serviceHelper(
    http.patch(`/user/block-unblock/${id}?record_type=${recordType}`, payload),
    true
  );
};

export const addTeacher = async (payload: IAddTeacherPayload) => {
  return serviceHelper(http.post('/school/teacher', payload), true);
};

export const updateTeacher = async (
  id: string,
  payload: IAddTeacherPayload
) => {
  return serviceHelper(http.patch(`/school/teacher/${id}`, payload), true);
};

export const getTeacherDropdown = async (exclude_block?: boolean) => {
  return serviceHelper(
    http.get('/school/teacher/dropdown', {
      params: { exclude_block },
    }),
    false
  );
};

export const getClassTeacherDropdown = async (exclude_block?: boolean) => {
  return serviceHelper(
    http.get('/school/class-teacher/dropdown', {
      params: { exclude_block },
    }),
    false
  );
};

export const getTeacherClasses = async (id: string) => {
  return serviceHelper(http.get(`/school/teacher/${id}/classes`), false);
};

export const getTeacherStudents = async (
  id: string,
  query?: Record<string, unknown>
) => {
  const queryString = query ? formatQuery(query) : '';
  const url = queryString
    ? `/school/teacher/${id}/students?${queryString}`
    : `/school/teacher/${id}/students`;

  return serviceHelper(http.get(url), false);
};

export const getSeeMoreTeachers = async (query: ISeeMoreTeachersQuery) => {
  const queryString = formatQuery(query);
  return serviceHelper(
    http.get(`/school/see-more/teachers?${queryString}`),
    false
  );
};

export const getSeeMoreClasses = async (query: ISeeMoreClassesQuery) => {
  const queryString = formatQuery(query);
  return serviceHelper(
    http.get(`/school/see-more/classes?${queryString}`),
    false
  );
};

export const getTeacherProfile = async () => {
  return serviceHelper(http.get('/teacher'), false);
};
